/* eslint-disable no-param-reassign */

import Vue from 'vue';
import Vuex from 'vuex';
import createPersist from 'vuex-localstorage';
import {
  cloneDeep,
} from 'lodash/fp';

import defaultAccomodationsFilter from '@/store-methods/defaultAccomodationsFilter';

import {
  changeFreeSearch,
  changeRooms,
  changeBeds,
  toggleDatepicker,
  toggleFilters,
  toggleMap,
  toggleFilterSwitch,
  toggleSkiSchoolFilterSwitch,
  toggleSkiSchoolFilterAgeSwitch,
  toggleSkiSchoolSubFilter,
  resetAccomodationsFilter,
  toggleSearch,
  setAccomodationsFilterStartDate,
  setAccomodationsFilterEndDate,
  setAccomodationsAvailableIds,
  setFilterLocationId,
  resetSkiSchoolFilter,
  changeSorting,
} from '@/store-methods/mutations/search';

import {
  pickAccomodation,
  confirmAccomodation,
  confirmSkipasses,
  unconfirmSkipasses,
  addAddon,
  removeAddon,
  addSkipasses,
  addAccomodationSkipasses,
  accomodationPeriodPick,
  addFavorite,
  removeFavorite,
  refreshFavorites,
  refreshCart,
  clearCart,
  setUser,
  setUserCode,
  awaitFilter,
  dontAwaitFilter,
  saveCartLocking,
} from '@/store-methods/mutations/accomodation';

import {
  confirmedAccomodations,
  favoriteAccommodations,
  loggedIn,
  isAwaitingFilter,
  accomodationsFilterEndDate,
  accomodationsFilter,
} from '@/store-methods/getters/accomodation';

import {
  addRentalPeople,
  updateRentalPerson,
  addProducts,
  confirmRental,
  completeGuides,
  addRentalAddon,
  removeRentalAddon,
  setOnSite,
  setOffSite,
  setGuideCompleted,
} from '@/store-methods/mutations/rental';

import {
  confirmedRentals,
  guidedRentals,
} from '@/store-methods/getters/rental';

import {
  addSkiPassPeople,
  updateSkiPassPerson,
  confirmSkiPass,
  completeSkipassGuides,
  addProduct,
} from '@/store-methods/mutations/skipass';

import {
  confirmedPasses,
  guidedPasses,
} from '@/store-methods/getters/pass';

import {
  resetPasswordSuccessMessage,
} from '@/store-methods/getters/log-in';

import {
  updateResetPasswordSuccessMessage,
} from '@/store-methods/mutations/log-in';


import {
  addSkiSchoolToCart,
  addActivitityToCart,
  setSkischoolFilter,
  setSkischoolFilterAttribute,
  consolidateSkiSchoolInCart,
} from '@/store-methods/mutations/skischool';

import {
  updatePincode,
  updateCampaignCode,
  updateCampaignCodeExtraInfo,
  updateUserDetails,
} from '@/store-methods/mutations/booking';


Vue.use(Vuex);

// root state object.
// each Vuex instance is just a single state tree.
const initialState = {
  accomodationsFilter: cloneDeep(defaultAccomodationsFilter),
  skiSchoolFilter: {},
  tempCartAccomodation: {},
  showDatepicker: false,
  showFilters: false,
  showMap: false,
  showSearch: false,
  openModals: [],
  openTimeoutModals: [],
  currentRequests: 0,
  devSettings: {},
  favorites: [],
  user: {
    token: '',
    object: {},
  },
  cartSum: '',
  cart: {
    accomodations: [],
    currentAccomodationIndex: 0,
    skipasses: [],
    currentSkipassIndex: 0,
    addons: [],
    currentAddonIndex: 0,
    rentals: [],
    currentRentalIndex: 0,
    skischools: [],
    pincode: null,
    campaignCode: null,
    codeRequiresExtraInfo: false,
    codeExtraInfo: '',
    ssn: null,
    products: [],
    deliveryTo: {},
    addToOrder: {},
  },
  user_code: null,
  skiSchoolBooking: {},
  isOnSite: false,
  isDebugging: false,
  isOnWhichSite: false,
  isAwaitingFilter: false,
  onsite_key: '',
  resetPasswordSuccessMessage: '',
  phone: null,
  email: null,
  name: null,
  lastName: '',
  notes: null,
};

function updateBodyModalAwareness(modal) {
  if (modal) {
    document.body.classList.add('modal-opened');
  } else {
    document.body.classList.remove('modal-opened');
  }
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  increaseCurrentRequests(state) {
    state.currentRequests += 1;
  },
  decreaseCurrentRequests(state) {
    state.currentRequests -= 1;
  },
  currentRequests(state) {
    return state.currentRequests;
  },
  changeFreeSearch,
  changeRooms,
  changeBeds,
  toggleDatepicker,
  toggleFilters,
  toggleMap,
  toggleFilterSwitch,
  toggleSkiSchoolFilterSwitch,
  toggleSkiSchoolFilterAgeSwitch,
  toggleSkiSchoolSubFilter,
  resetAccomodationsFilter,
  toggleSearch,
  setAccomodationsFilterStartDate,
  setAccomodationsFilterEndDate,
  setAccomodationsAvailableIds,
  setFilterLocationId,
  awaitFilter,
  dontAwaitFilter,
  resetSkiSchoolFilter,
  saveCartLocking,
  changeSorting,

  pickAccomodation,
  confirmAccomodation,
  confirmSkipasses,
  unconfirmSkipasses,
  addAddon,
  removeAddon,
  addAccomodationSkipasses,
  addSkipasses,
  addFavorite,
  removeFavorite,
  refreshFavorites,
  refreshCart,
  clearCart,
  setUser,

  setUserCode,

  setSkischoolFilter,
  setSkischoolFilterAttribute,

  accomodationPeriodPick,

  addRentalPeople,
  updateRentalPerson,
  addProducts,
  confirmRental,
  completeGuides,
  addRentalAddon,
  removeRentalAddon,
  setOnSite,
  setOffSite,
  setGuideCompleted,

  addSkiPassPeople,
  updateSkiPassPerson,
  confirmSkiPass,
  completeSkipassGuides,
  addProduct,

  addSkiSchoolToCart,
  addActivitityToCart,
  consolidateSkiSchoolInCart,

  updateUserDetails,

  removeCartItem(state, payload) {
    state.cart[payload.type].splice(payload.index, 1);
    state.cart.currentSkipassIndex = state.cart.skipasses.length - 1;
    refreshCart(state);
  },
  openModal(state, [component, params]) {
    const newModal = {
      ...params,
      component,
    };

    if (state.openModals.length) {
      const last = JSON.stringify(state.openModals[state.openModals.length - 1]);
      const theNew = JSON.stringify(newModal);
      if (last === theNew) {
        updateBodyModalAwareness(state.openModals.length);
        return true;
      }
    }

    state.openModals = [...state.openModals, newModal];
    updateBodyModalAwareness(state.openModals.length);
    return true;
  },
  openTimeoutModal(state, [component, params]) {
    const newModal = {
      ...params,
      component,
    };
    if (!state.openTimeoutModals.length) {
      state.openTimeoutModals = [...state.openTimeoutModals, newModal];
      updateBodyModalAwareness(state.openTimeoutModals.length);
    }
  },
  closeModal(state) {
    state.openModals = state.openModals.slice(0, -1);
    updateBodyModalAwareness(state.openModals.length);
  },
  closeTimeoutModal(state) {
    state.openTimeoutModals = state.openTimeoutModals.slice(0, -1);
    updateBodyModalAwareness(state.openModals.length);
  },
  closeAllModals(state) {
    state.openModals = [];
    updateBodyModalAwareness();
  },
  saveDevSettings(state, payload) {
    state.devSettings = Object.assign(state.devSettings, payload);
  },
  updatePincode,
  updateCampaignCode,
  updateCampaignCodeExtraInfo,
  updateResetPasswordSuccessMessage,
};

// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {};

// getters are functions
const getters = {
  bedsCount: state => state.accomodationsFilter.beds,
  getFreeSearch: state => state.accomodationsFilter.freeSearch,
  roomsCount: state => state.accomodationsFilter.bedrooms,
  datepickerToggle: state => state.showDatepicker,
  filtersToggle: state => state.showFilters,
  searchToggle: state => state.showSearch,
  mapToggle: state => state.showMap,
  cart: state => state.cart,
  currentModal: state => state.openModals[state.openModals.length - 1],
  currentTimeoutModal: state => (state.openTimeoutModals[0]),
  confirmedAccomodations,
  favoriteAccommodations,
  loggedIn,
  isAwaitingFilter,
  accomodationsFilterEndDate,
  accomodationsFilter,
  confirmedRentals,
  guidedRentals,
  confirmedPasses,
  guidedPasses,
  devSettings: state => state.devSettings,
  resetPasswordSuccessMessage,
};

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
  plugins: [createPersist({
    namespace: 'branas-booking',
    initialState: {},
    // ONE_WEEK
    expires: 7 * 24 * 60 * 60 * 1e3,
  })],
  state: initialState,
  getters,
  actions,
  mutations,
});



// WEBPACK FOOTER //
// ./src/store.js